import { render, staticRenderFns } from "./PrincipalFooter.vue?vue&type=template&id=03dfa727&scoped=true&"
var script = {}
import style0 from "./PrincipalFooter.vue?vue&type=style&index=0&id=03dfa727&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dfa727",
  null
  
)

export default component.exports